import { DrawerBody, VStack } from '@chakra-ui/react';
import React, { useState } from 'react';

import { DataPipeline } from '@finley-technologies/finley-types';

import { MeshSelect } from './MeshSelect';
import { PipelineSelectorPane } from './PipelineSelectorPane';
import { PipelinesPageLink } from 'packages/dataPipeline/ui/uploads/PipelineDetailsPageLink';
import { SelectedMeshRun } from '~/packages/dataPipeline/types/dataPipelineTypes';

/**
 * Select an existing mesh run for uploading data or viewing progress
 */
export const SelectExistingMeshRun = ({
  latestMeshDocuments,
  allRecentMeshRuns,
  onPipelineSelected,
  onClose,
}: {
  latestMeshDocuments: DataPipeline.MeshDocumentMetadata[];
  allRecentMeshRuns: DataPipeline.MeshRunRecord[];
  onPipelineSelected(selectedMeshRun: SelectedMeshRun): void;
  onClose: () => void;
}) => {
  const [
    selectedMeshDocument,
    setSelectedMeshDocument,
  ] = useState<DataPipeline.MeshDocumentMetadata | null>(
    latestMeshDocuments.length === 1 ? latestMeshDocuments[0] : null,
  );

  // for each meshRunRecord find the corresponding mesh document
  // and add its meshName to the meshRunRecord
  const meshRunRecordsWithLatestDocument = allRecentMeshRuns
    .map((meshRun) => {
      const latestMeshDocument =
        latestMeshDocuments.find(
          (doc) => doc.meshDocumentId === meshRun.meshDocumentId,
        ) || null;

      // its possible that we have a mesh run that doesn't have a corresponding mesh document
      // this can happen if mesh run was against older version of the mesh document.
      // PipelineSelectorPane will render these but will not allow selecting them.
      return {
        ...meshRun,
        latestMeshDocument,
      };
    })
    .filter((meshRun) => {
      // if a specific mesh document is selected,
      // limit our choices to it.
      return selectedMeshDocument
        ? meshRun.meshDocumentId === selectedMeshDocument.meshDocumentId
        : true;
    });

  return (
    <DrawerBody>
      <VStack spacing="20px" alignItems="flex-start">
        {/* select credit facility/mesh */}
        <MeshSelect
          allowSelection
          allowAllOption
          selectedMeshDocumentId={selectedMeshDocument?.meshDocumentId ?? null}
          onMeshSelected={setSelectedMeshDocument}
          meshDocuments={latestMeshDocuments}
        />
        <PipelineSelectorPane
          recentMeshRuns={meshRunRecordsWithLatestDocument}
          onPipelineSelected={onPipelineSelected}
        >
          <PipelinesPageLink onLinkClick={onClose} />
        </PipelineSelectorPane>
      </VStack>
    </DrawerBody>
  );
};
